import { cn } from "@/lib/utils"

// IMP-461: the reduced setup guides frame each decision as a yes/no pair with
// sublabels describing what each choice entails.
//
// Labels name the capability ("Yes, take messages") rather than reading a bare
// "Yes", so a card says what it does without the header above it. The sublabel
// then carries what the label can't — what the agent actually does — in the
// agent's own voice, matching the first-person step headers.
export function YesNoCards({
  yesLabel,
  yesSub,
  noLabel,
  noSub,
  value,
  onChange,
}: {
  yesLabel: string
  yesSub: string
  noLabel: string
  noSub: string
  value: boolean
  onChange: (v: boolean) => void
}) {
  const options = [
    { value: true, label: yesLabel, sub: yesSub },
    { value: false, label: noLabel, sub: noSub },
  ]
  return (
    // No `items-start`: grid items stretch by default, so the two cards match
    // heights whichever sublabel wraps longer.
    <div className="grid grid-cols-2 gap-3">
      {options.map((opt) => {
        const selected = value === opt.value
        return (
          <button
            key={opt.label}
            type="button"
            onClick={() => onChange(opt.value)}
            className={cn(
              // `flex flex-col` so the label and sublabel sit at the top of a
              // stretched card — a button centers its content vertically
              // otherwise, leaving the shorter card's text floating.
              "flex flex-col rounded-lg border p-4 text-left transition-colors",
              selected
                ? "border-blue-300 bg-gradient-to-b from-blue-50 to-white dark:from-blue-950/60 dark:to-blue-900/20"
                : "border-border hover:bg-muted/30",
            )}
          >
            <p
              className={cn(
                "text-sm leading-tight font-semibold",
                selected && "text-blue-600 dark:text-blue-400",
              )}
            >
              {opt.label}
            </p>
            <p
              className={cn(
                "mt-0.5 text-sm leading-relaxed",
                selected
                  ? "text-blue-600 dark:text-blue-400"
                  : "text-muted-foreground",
              )}
            >
              {opt.sub}
            </p>
          </button>
        )
      })}
    </div>
  )
}
